var $winetestquiz,
    $wintestInfo,
    $numQuestions,
    $questionTime,
    $currentQuestionIndex,
    $questions,
    $progressbar,
    $progress,
    $progressInterval,
    $resultContainer,
    $answersGiven,
    $answerContainer;


$(document).ready(function($) {

    $winetestquiz = $('.js-winetest-quiz');
    $wintestInfo = $('.js-winetest-info');
    $questionTime = $winetestquiz.data('time');
    $numQuestions = $winetestquiz.data('numquestions');
    $currentQuestionIndex = 0;
    $questions = $('.js-winetest-question');
    $progressbar = $('.js-winetest-progressbar');
    $resultContainer = $('.js-winetest-result');
    $answerContainer = $('.js-winetest-show-answers');
    $progress = 1;
    $answersGiven = [];


    $('.js-open-winetest-quiz').on('click', function(){
        $wintestInfo.hide("slow");
        $winetestquiz.addClass('open');
        setQuestion();

    });

    $('.js-open-winetest-answers').on('click', function(){
        $resultContainer.hide();
        showWrongAnswers();
    });
    $('.js-winetest-close').on('click', function(){
        $wintestInfo.show();
        $winetestquiz.removeClass('open');
        $progress = 1;
        $answersGiven = [];
        $currentQuestionIndex = 0;
    });

    $('.js-winetest-show-answers-back').on('click', function(){
        $answerContainer.hide();
        $('.js-winetest-show-answers-calculated').html('');
        $resultContainer.show();
    });

    $('.js-answer-question').on('click', function(){
        $answersGiven.push({
            question: $(this).data('question'),
            answer: $(this).data('answer'),
            correct: $(this).data('answer-letter') == $(this).data('correct'),
            correctAnswer: $(this).data('correct')
        });
        nextQuestion();
    });



    function setQuestion(){
        $questions.each(function(index){
            if($(this).hasClass('js-winetest-question_'+ $currentQuestionIndex)){
                $(this).addClass('current');
                $progressInterval = setInterval(updateProgress, 1000)
            }else{
                $(this).removeClass('current');
            }
        });
    }

    function updateProgress(){
        if($progress < Number($questionTime)){
            $progress += 1;
            $progressbar.width((100/Number($questionTime))*$progress +'%');
        }else{
            nextQuestion();
        }

    }
    function resetProgress(){
        $progress = 1;
        $progressbar.width('1%');
        clearInterval($progressInterval);
    }

    function nextQuestion(){
        resetProgress();
        $currentQuestionIndex = $currentQuestionIndex+1;
        setQuestion();
        if($currentQuestionIndex == $numQuestions){
            showResult();
        }
    }

    function showResult(){
        var score = 0;
        for(var i = 0; i < $answersGiven.length; i++){
            if($answersGiven[i].correct === true){
                score +=1;
            }
        }
        for(var j = 0; j < advice.length; j++){
            if(score <= advice[j].score){
                $('.js-winetest-final-image').attr("src", advice[j].icon);
                $('.js-winetest-final-score').html(score);
                $('.js-winetest-advice-text').html(advice[j].advice);
                $('.js-open-winetest-course').attr("href", advice[j].course_url);
               break;
            }
        };
       $resultContainer.show('slow');

    }

    function showWrongAnswers(){
        var wrong = 0;
        var html = '';
        for(var i = 0; i < $answersGiven.length; i++){
            if($answersGiven[i].correct === false){
                wrong += 1;
                var correctAnswer = getCorrectAnswer($answersGiven[i].question, $answersGiven[i].correctAnswer);
                html += '<div class="t-winetest-quiz__show-answers-question-container">\n' +
                    '<div class="t-winetest-quiz__show-answers-question">'+(i+1)+'. '+$answersGiven[i].question+':</div>\n' +
                    '<div class="t-winetest-quiz__show-answers-answer">Jouw antwoord: '+$answersGiven[i].answer+'. Juiste antwoord: '+correctAnswer+'</div>\n' +
                    '</div>'

            }
        }
        $('.js-winetest-show-answers-calculated').html(html);
        $('.js-winetest-final-score-wrong').html(wrong);
        $answerContainer.show();
    }



    function getCorrectAnswer(question, letter){


        for(var j = 0; j< questions.length; j++){
            if(questions[j].question == question){

                if(letter == 'A'){
                    return questions[j].anwser_a
                }
                else if(letter == 'B'){
                    return questions[j].anwser_b
                }
                else if(letter == 'C'){
                    return questions[j].anwser_c
                }
                else{
                    return questions[j].anwser_d
                }
            }
        }
    }

});